// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Collapsable: MarkdocTagRegistration = {
  tag: 'collapsable',
  component: 'Collapsable',
  children: [
    'heading',
    'paragraph',
    'image',
    'table',
    'tag',
    'fence',
    'blockquote',
  ],
  attributes: {
    open: {
      type: Boolean,
      default: false,
      description: 'Set to true if you would like it to be open initially.',
    },
    heading: {type: String, required: true, localizable: true},
    id: {
      type: String,
      required: false,
      description:
        'Set an id if you want it to be anchorable and display an anchor link.',
    },
  },
};
